import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, onSnapshot, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

const SIGNAL_TYPES = [
  { id: "intraday", name: "Intraday" },
  { id: "short", name: "Short-term" },
  { id: "medium", name: "Medium-term" }
];

export default function AnalystDashboard() {
  const [user, setUser] = useState(null);
  const [signals, setSignals] = useState([]);
  const [editingSignal, setEditingSignal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        window.location.href = '/signup';
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) return;

    const q = query(
      collection(db, 'signals_v2'),
      where('analyst_id', '==', user.uid),
      where('status', '==', 'active')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const signalsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSignals(signalsList);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  const handleEdit = (signal) => {
    setEditingSignal({ ...signal });
  };

  const handleDelete = async (signalId) => {
    if (window.confirm('هل أنت متأكد من حذف هذه التوصية؟')) {
      try {
        await deleteDoc(doc(db, 'signals_v2', signalId));
        setMessage("✅ تم حذف التوصية بنجاح!");
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        console.error("Error deleting signal:", error);
        setMessage("❌ فشل حذف التوصية.");
      }
    }
  };

  const handleSave = async () => {
    if (!editingSignal) return;

    try {
      if (editingSignal.source === 'auto') {
        throw new Error("لا يمكنك تعديل التوصيات الآلية");
      }

      const entry = parseFloat(editingSignal.entry_price);
      const sl = parseFloat(editingSignal.stop_loss);
      const tp = parseFloat(editingSignal.take_profit);

      if (editingSignal.action === "BUY") {
        if (tp <= entry) throw new Error("الهدف يجب أن يكون أعلى من سعر الدخول");
        if (sl >= entry) throw new Error("وقف الخسارة يجب أن يكون أقل من سعر الدخول");
      } else {
        if (tp >= entry) throw new Error("الهدف يجب أن يكون أقل من سعر الدخول");
        if (sl <= entry) throw new Error("وقف الخسارة يجب أن يكون أعلى من سعر الدخول");
      }

      await updateDoc(doc(db, 'signals_v2', editingSignal.id), {
        entry_price: entry,
        stop_loss: sl,
        take_profit: tp,
        signal_type: editingSignal.signal_type,
        confidence_score: parseInt(editingSignal.confidence_score)
      });

      setEditingSignal(null);
      setMessage("✅ تم تحديث التوصية بنجاح!");
      setTimeout(() => setMessage(""), 3000);

    } catch (error) {
      console.error("Error updating signal:", error);
        setMessage(`❌ خطأ: ${error.message}`);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <h2 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        إدارة التوصيات اليدوية
      </h2>
      
      {message && (
        <div style={{ 
          padding: '12px', 
          borderRadius: '8px', 
          backgroundColor: message.includes('✅') ? '#f0fdf4' : '#fef2f2',
          color: message.includes('✅') ? '#166534' : '#b91c1c',
          marginBottom: '20px',
          border: message.includes('✅') ? '1px solid #bbf7d0' : '1px solid #fecaca'
        }}>
          {message}
        </div>
      )}

      {signals.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          backgroundColor: 'white', 
          borderRadius: '12px',
          border: '1px dashed #cbd5e1'
        }}>
          <p>لا توجد توصيات يدوية نشطة</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {signals.map(signal => (
            <div key={signal.id} style={{ 
              border: '1px solid #e2e8f0', 
              padding: '16px', 
              borderRadius: '12px',
              backgroundColor: '#f8fafc'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                  <h3 style={{ margin: '0', color: '#0f172a' }}>
                    🟢 {signal.action} {signal.ticker}
                    {signal.ticker_name && (
                      <span style={{ fontSize: '14px', color: '#64748b', marginLeft: '8px' }}>
                        ({signal.ticker_name})
                      </span>
                    )}
                  </h3>
                  <div style={{ marginTop: '8px', display: 'flex', gap: '12px', fontSize: '14px' }}>
                    <span>النوع: <strong>{signal.signal_type}</strong></span>
                    <span>الثقة: <strong>{signal.confidence_score}%</strong></span>
                  </div>
                </div>
                <div>
                  <button 
                    onClick={() => handleEdit(signal)}
                    style={{
                      backgroundColor: '#1e40af',
                      color: 'white',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      marginRight: '8px'
                    }}
                  >
                    تعديل
                  </button>
                  <button 
                    onClick={() => handleDelete(signal.id)}
                    style={{
                      backgroundColor: '#dc2626',
                      color: 'white',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    حذف
                  </button>
                </div>
              </div>
              
              <div style={{ marginTop: '12px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>سعر الدخول</div>
                  <div style={{ fontWeight: 'bold' }}>{signal.entry_price}</div>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>الهدف</div>
                  <div style={{ fontWeight: 'bold', color: '#16a34a' }}>{signal.take_profit}</div>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>وقف الخسارة</div>
                  <div style={{ fontWeight: 'bold', color: '#dc2626' }}>{signal.stop_loss}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* نموذج التعديل */}
      {editingSignal && (
        <div style={{ 
          marginTop: '32px', 
          backgroundColor: 'white', 
          padding: '24px', 
          borderRadius: '12px',
          border: '1px solid #e2e8f0'
        }}>
          <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
            تعديل التوصية: {editingSignal.ticker}
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                سعر الدخول
              </label>
              <input
                type="number"
                value={editingSignal.entry_price}
                onChange={(e) => setEditingSignal({ ...editingSignal, entry_price: e.target.value })}
                step="0.01"
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                وقف الخسارة
              </label>
              <input
                type="number"
                value={editingSignal.stop_loss}
                onChange={(e) => setEditingSignal({ ...editingSignal, stop_loss: e.target.value })}
                step="0.01"
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الهدف
              </label>
              <input
                type="number"
                value={editingSignal.take_profit}
                onChange={(e) => setEditingSignal({ ...editingSignal, take_profit: e.target.value })}
                step="0.01"
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              نوع التوصية
            </label>
            <select
              value={editingSignal.signal_type}
              onChange={(e) => setEditingSignal({ ...editingSignal, signal_type: e.target.value })}
              style={{ width: '200px', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              {SIGNAL_TYPES.map(type => (
                <option key={type.id} value={type.id}>{type.name}</option>
              ))}
            </select>
          </div>
          
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={handleSave}
              style={{
                backgroundColor: '#1e40af',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              حفظ التعديلات
            </button>
            <button
              onClick={() => setEditingSignal(null)}
              style={{
                backgroundColor: '#64748b',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              إلغاء
            </button>
          </div>
        </div>
      )}
    </div>
  );
}